import React, { useEffect, useState } from "react"
import { Button, Form, Select } from "antd"
import { PlusOutlined } from "@ant-design/icons"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import { Card } from "ui/Card"
import { Text } from "ui/Typography"
import { DocumentsAddedModal } from "pagesV2/pro/DigitalWaiverAndContracts/DocumentsAdded/modal/DocumentsAdded"
import { getGuideDigitalWaivers } from "store/digital-waiver"
import { useDevice } from "hooks/useDevice"
import styles from "./DigitalWaiver.module.css"

export const DigitalWaiver = () => {
  const { t } = useTranslation()
  const { isMobile } = useDevice()
  const dispatch = useDispatch()
  const waivers = useSelector((state) => state.digitalWaiver.items)
  const isLoading = useSelector((state) => state.digitalWaiver.loading)
  const [isModalOpen, setIsModalOpen] = useState(false)

  useEffect(() => {
    dispatch(getGuideDigitalWaivers({ paginate: false }))
  }, [dispatch])

  const waiverOptions = waivers.map((w) => ({ value: w.id, label: w.name }))

  const handleModalSave = () => {
    setIsModalOpen(false)
    dispatch(getGuideDigitalWaivers({ paginate: false }))
  }

  return (
    <>
      <Card
        title={t("experiences.wizard.additional_info.digital_waiver.title")}
        className="mb-xl"
        extra={
          <Button type="primary" icon={<PlusOutlined />} onClick={() => setIsModalOpen(true)} className={styles.addNewBtn}>
            {isMobile ? t("common.add") : t("experiences.wizard.additional_info.digital_waiver.add_btn")}
          </Button>
        }
      >
        <Text className={`mb-m ${styles.description}`}>
          {t("experiences.wizard.additional_info.digital_waiver.description")}
        </Text>
        <Form.Item
          name="digital_waiver"
          label={t("experiences.wizard.additional_info.digital_waiver.label")}
          colon={false}
          className="mb-0"
        >
          <Select
            mode="multiple"
            showSearch
            filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
            options={waiverOptions}
            loading={isLoading}
            placeholder={t("experiences.wizard.additional_info.digital_waiver.placeholder")}
            size="large"
            className={styles.select}
          />
        </Form.Item>
      </Card>

      {isModalOpen && (
        <DocumentsAddedModal
          isLoading={false}
          setIsLoading={() => {}}
          visible={isModalOpen}
          onCancel={() => setIsModalOpen(false)}
          onSave={handleModalSave}
          useDrawerOnMobile
        />
      )}
    </>
  )
}
